<template>
    <div class="from-to-date">
        <div class="date-row">
            <Icon name="from_to_date_icon" class="date-icon" />
            <span class="date-text">{{ formattedFromDate }}</span>
        </div>
        <div v-if="to_date" class="date-row">
            <span class="date-text">{{ formattedToDate }}</span>
            <Icon name="date_to_from_icon" class="date-icon" />
        </div>
        <div v-else-if="show_open_ended" class="date-row">
            <EXTooltip placement="top" :title="OPEN_ENDED_TOOLTIP">
                <span class="date-text date-text--open-ended" tabindex="0" :aria-label="OPEN_ENDED_TOOLTIP">{{ OPEN_ENDED_DASH }}</span>
            </EXTooltip>
            <Icon name="date_to_from_icon" class="date-icon" />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import Icon from '@components/icons/Icon.vue'
import EXTooltip from '@components/tooltip/EXTooltip.vue'
import { OPEN_ENDED_DASH, OPEN_ENDED_TOOLTIP, parseLocalDate } from '@components/utils/effectiveDated'

const props = defineProps({
    from_date: {
        type: [Date, String, Number],
        required: true,
        default: () => new Date()
    },
    to_date: {
        type: [Date, String, Number],
        default: null
    },
    // Render "—" (tooltip "Open-ended") when to_date is empty, for effective-dated records.
    show_open_ended: {
        type: Boolean,
        default: false
    }
})

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const formatDate = (dateValue) => {
    if (!dateValue) return ''

    // P9 (MDP-614): calendar dates are parsed as local days, never `new Date(str)` (UTC shift).
    const date = parseLocalDate(dateValue)
    if (!date) return ''
    return `${date.getDate()}-${MONTHS[date.getMonth()]}-${date.getFullYear()}`
}

const formattedFromDate = computed(() => formatDate(props.from_date))
const formattedToDate = computed(() => formatDate(props.to_date))
</script>

<style scoped>
.from-to-date {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 8px 12px;
    gap: 4px;
}

.date-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.date-icon {
    flex-shrink: 0;
}

.date-text {
    font-size: 14px;
    color: #333;
    white-space: nowrap;
}

.date-text--open-ended {
    cursor: default;
}
</style>